(function () {
  'use strict';
  /* Helper prix ToudouPet (miroir du snippet toudoupet-price.liquid).
     parts / text / markup / render / animate : composant prix.
     pairOffer(unitCents, pct) : SOURCE UNIQUE du calcul « Achetez 2 » —
     reproduit la regle d'allocation Shopify observee au panier : la remise
     est calculee PAR UNITE et arrondie A L'INFERIEUR au centime
     (24,99 € x 20 % = 4,998 -> 4,99 ; 2 x (24,99 - 4,99) = 40,00 €).
     Le snippet Liquid applique la meme regle (division entiere). */
  var THOUSANDS = /\B(?=(\d{3})+(?!\d))/g;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function parts(cents) {
    var c = Math.round(Number(cents) || 0);
    var major = Math.floor(c / 100);
    var minor = String(c % 100);
    if (minor.length < 2) minor = '0' + minor;
    var majorStr = String(major).replace(THOUSANDS, '\u202F');
    return { major: majorStr, minor: minor };
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function label(p, prefix) { return (prefix ? prefix + ' ' : '') + p.major + ',' + p.minor + ' euros'; }
  /* Texte lu par les lecteurs d'ecran (meme structure que le snippet Liquid : span .tp-visually-hidden, les parties visuelles restent aria-hidden). */
  function hidden(p, prefix) { return '<span class="tp-visually-hidden">' + esc(label(p, prefix)) + '</span>'; }
  function text(cents) { var p = parts(cents); return p.major + ',' + p.minor + '\u00A0€'; }
  function markup(cents, opts) {
    opts = opts || {};
    var p = parts(cents);
    return '<span class="tp-price' + (opts.klass ? ' ' + esc(opts.klass) : '') + '">' + hidden(p, opts.prefix) +
      (opts.prefix ? '<span class="tp-price__prefix" aria-hidden="true">' + esc(opts.prefix) + '&nbsp;</span>' : '') +
      '<span class="tp-price__major" aria-hidden="true">' + p.major + '</span>' +
      '<span class="tp-price__minor" aria-hidden="true">,' + p.minor + '</span>' +
      '<span class="tp-price__currency" aria-hidden="true">&nbsp;€</span></span>';
  }
  function render(el, cents, opts) {
    if (!el) return;
    window.clearTimeout(el._tpRollTimer);
    el.innerHTML = markup(cents, opts);
    el.setAttribute('data-price-cents', String(Math.round(Number(cents) || 0)));
  }
  function roll(oldStr, newStr, state) {
    var o = oldStr.split(''), n = newStr.split('');
    while (o.length < n.length) o.unshift('');
    while (n.length < o.length) n.unshift('');
    var html = '';
    for (var i = 0; i < n.length; i++) {
      if (n[i] === '') continue;
      var nc = n[i] === ' ' ? '&nbsp;' : esc(n[i]);
      var oc = o[i] === ' ' ? '&nbsp;' : esc(o[i]);
      if (o[i] === n[i]) html += '<span class="tp-pa__c">' + nc + '</span>';
      else { html += '<span class="tp-pa__c tp-pa__c--anim" style="--i:' + state.idx + '"><span class="tp-pa__old">' + oc + '</span><span class="tp-pa__new">' + nc + '</span></span>'; state.idx++; }
    }
    return html;
  }
  function animate(el, fromCents, toCents, opts) {
    if (!el) return;
    opts = opts || {};
    var from = Math.round(Number(fromCents) || 0), to = Math.round(Number(toCents) || 0);
    if (reduce || from === to || !window.requestAnimationFrame) { render(el, to, opts); return; }
    var dir = to > from ? 'tp-pa--up' : 'tp-pa--down';
    var po = parts(from), pn = parts(to);
    var state = { idx: 0 };
    var majorHtml = roll(po.major, pn.major, state);
    var minorHtml = roll(',' + po.minor, ',' + pn.minor, state);
    window.clearTimeout(el._tpRollTimer);
    el.innerHTML = '<span class="tp-price tp-pa ' + dir + (opts.klass ? ' ' + esc(opts.klass) : '') + '">' + hidden(pn, opts.prefix) +
      (opts.prefix ? '<span class="tp-price__prefix" aria-hidden="true">' + esc(opts.prefix) + '&nbsp;</span>' : '') +
      '<span class="tp-price__major" aria-hidden="true">' + majorHtml + '</span>' +
      '<span class="tp-price__minor" aria-hidden="true">' + minorHtml + '</span>' +
      '<span class="tp-price__currency" aria-hidden="true">&nbsp;€</span></span>';
    el.setAttribute('data-price-cents', String(to));
    el._tpRollTimer = window.setTimeout(function () { render(el, to, opts); }, 420 + state.idx * 55 + 80);
  }
  /* Offre « Achetez 2 » : montants tels que Shopify les facture. */
  function pairOffer(unitCents, pct) {
    var unit = Math.round(Number(unitCents) || 0);
    var p = Math.round(Number(pct) || 0);
    var unitDiscount = Math.floor(unit * p / 100);
    var full = unit * 2;
    var discounted = (unit - unitDiscount) * 2;
    return { full: full, discounted: discounted, saving: full - discounted, unitDiscount: unitDiscount };
  }
  window.ToudouPrice = { parts: parts, text: text, markup: markup, render: render, animate: animate, pairOffer: pairOffer };
})();